import { MonoService } from 'api/rest/config';
import { Collaborator } from './types';
import { AxiosResponse } from 'axios';

export const getCollaborator = async (collaboratorId: string) => {
  return MonoService.get<Collaborator, AxiosResponse>(
    `/v1/collaborator/${collaboratorId}`
  ).then((response) => response.data);
};
